export const RECEIVE_USER_CANVASES = 'RECEIVE_USER_CANVASES'
export const RECEIVE_CANVAS = 'RECEIVE_CANVAS'
export const DELETE_CANVAS = 'DELETE_CANVAS'
